import React, { Component } from 'react'
import './App.scss'
import Navbar from './components/Navbar/Navbar.js'
import Main from './components/Main/Main.js'
import Footer from './components/Footer/Footer.js'
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom"
import Privacy from './components/Privacy/Privacy.js'
import NavbarDrone from './components/Navbar/NavbarDrone.js'
import Drone from './components/Drone/Drone.js'
import Cookie from './components/Cookie/Cookie.js'
import ReactGA from 'react-ga'

class App extends Component {

    constructor(props) {
        super(props);
        this.state = { scroll: false, display: 'main' };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentDidUnMount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        if (window.pageYOffset > 0) {
            this.setState({ scroll: true });
        } else {
            this.setState({ scroll: false });
        }
    }

    onCookieAccepted = () => {
        ReactGA.initialize('UA-135520207-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
        return (
            <Router>
                <Switch>
                  <Route path="/privacy-policy">
                    <Privacy />
                  </Route>
                  <Redirect from="//drone" to="/drone" />
                  <Route path="/drone">
                      <div className="App">
                          <NavbarDrone scrolled={this.state.scroll} />
                          <Drone />
                          <Footer companyName="ERC Solutions Ltd trading as ERC Drone Productions" />
                      </div>
                  </Route>
                  <Route path="/">
                      <div className="App">
                          <Navbar scrolled={this.state.scroll} />
                          <Main />
                          <Footer companyName="ERC Solutions Ltd" />
                      </div>
                  </Route>
                </Switch>
                <Cookie onCookieAccepted={this.onCookieAccepted}/>
            </Router>
        )
     }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js